<template>
    <div class="tabs">
        <div :class="['tab', activeTab === TabEnum.VIEW ? 'active' : '']" @click="OpenTab(TabEnum.VIEW)">
            {{ $t('modals.patient_profile.profile.detail_form.tabs.view') }}
        </div>

        <div :class="['tab', activeTab === TabEnum.UPLOAD ? 'active' : '']" @click="OpenTab(TabEnum.UPLOAD)">
            {{ $t('modals.patient_profile.profile.detail_form.tabs.upload') }}
        </div>

        <div :class="['tab', activeTab === TabEnum.REQUEST ? 'active' : '', 'disabled-tab']" @click="OpenTab(TabEnum.REQUEST)">
            {{ $t('modals.patient_profile.profile.detail_form.tabs.request') }}
        </div>
    </div>
</template>

<script>
    const TabEnum = Object.freeze({
        VIEW: 'view',
        UPLOAD: 'upload',
        REQUEST: 'request',
    })

    export default {
        data() {
            return {
                TabEnum,
                activeTab: TabEnum.VIEW,
            }
        },
        methods: {
            OpenTab(name) {
                this.$emit('toggle', name)
                this.activeTab = name
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .tabs {
        display: flex;
        justify-content: space-around;
        margin-bottom: 15px;
        background: #e4e0e0;
        border-radius: 20px;
        overflow: hidden;
    }
    .tab {
        flex: 1;
        text-align: center;
        padding: 5px;
        cursor: pointer;
        color: $color--txt-base;
        font-size: 12px;
        margin: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .tab.active {
        background: white;
        font-weight: 500;
        border-radius: 32px;
        font-size: 13px;
        color: $color--txt-base;
    }
    @media screen and (max-width: 600px) {
        .tab,
        .tab.active {
            font-size: 10px;
        }
    }
    .disabled-tab {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
    }
</style>
